module.exports = __webpack_public_path__ + "img/Flyer-Soilmates-buitenweekend-2.6df950de.jpg";